import {
  PROP_TYPE_HINT,
  type PropTypeHint,
  type RegistryEntry,
} from "@/src/shared_modules/custom_elements/types/customElements";

const TEXT_CONTROL_PROP_TYPES: Record<string, PropTypeHint> = {
  inlineEdit: PROP_TYPE_HINT.Boolean,
  disabled: PROP_TYPE_HINT.Boolean,
  readonly: PROP_TYPE_HINT.Boolean,
  required: PROP_TYPE_HINT.Boolean,
  clearable: PROP_TYPE_HINT.Boolean,
  hiddenInput: PROP_TYPE_HINT.Boolean,
  maxlength: PROP_TYPE_HINT.Number,
  minlength: PROP_TYPE_HINT.Number,
};

export const TEXT_FIELD_REGISTRY_ENTRY: RegistryEntry = {
  loadComponent: () => import("@/src/design_system/form_elements/text_field/components/DSTextField.vue"),
  modelValueType: PROP_TYPE_HINT.String,
  propTypes: { ...TEXT_CONTROL_PROP_TYPES, hiddenLabel: PROP_TYPE_HINT.Boolean },
  exposedMethods: ["focus", "blur"],
  emits: ["focus", "blur", "click:suffix-action"],
  slots: ["suffix"],
};

export const TEXT_INPUT_REGISTRY_ENTRY: RegistryEntry = {
  loadComponent: () => import("@/src/design_system/form_elements/text_input/components/DSTextInput.vue"),
  modelValueType: PROP_TYPE_HINT.String,
  propTypes: { ...TEXT_CONTROL_PROP_TYPES, hasError: PROP_TYPE_HINT.Boolean },
  exposedMethods: ["focus", "blur"],
  emits: ["focus", "blur", "click:suffix-action"],
  slots: ["suffix"],
};
